import script from "./DetailTableListInvoiceProxyNonPOSP1.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailTableListInvoiceProxyNonPOSP1.vue?vue&type=script&setup=true&lang=js"

import "./DetailTableListInvoiceProxyNonPOSP1.vue?vue&type=style&index=0&id=3046e3bd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3046e3bd"]])

export default __exports__